export default __webpack_public_path__ + "static/media/zoomLogo.6d41227b.jpg";